import { render, staticRenderFns } from "./type-du-sinistre.vue?vue&type=template&id=c314e1b6"
import script from "./type-du-sinistre.vue?vue&type=script&lang=ts"
export * from "./type-du-sinistre.vue?vue&type=script&lang=ts"
import style0 from "./type-du-sinistre.vue?vue&type=style&index=0&id=c314e1b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports